module.exports = __webpack_public_path__ + "static/img/3.5d06ba2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/3.png
// module id = Cesi
// module chunks = 0